import {
  Component,
  computed,
  effect,
  ElementRef,
  inject,
  OnDestroy,
  untracked,
  viewChild,
} from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';

import { IconModule, SimpleInputModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';
import { asyncScheduler } from 'rxjs';

import { ButtonComponent, ShimmerComponent } from '@iw/common';

import { MessageComponent } from './item/item.component';
import { ORDER_METHOD_VALUE } from '../../../orders-history.constants';
import { OrdersHistoryStore } from '../../../orders-history.store';

@Component({
  selector: 'iw-order-messages',
  styleUrl: './messages.component.scss',
  templateUrl: './messages.component.html',
  imports: [
    TranslateModule,
    ButtonComponent,
    IconModule,
    SimpleInputModule,
    MessageComponent,
    ReactiveFormsModule,
    ShimmerComponent,
  ],
})
export class MessagesComponent implements OnDestroy {
  readonly #fb = inject(FormBuilder);
  readonly #store = inject(OrdersHistoryStore);

  readonly order = this.#store.order;
  readonly loading = this.#store.isSendCommentPending;

  readonly bottom = viewChild<ElementRef<HTMLElement>>('bottom');

  readonly comments = computed(() => {
    return this.order()?.comments;
  });
  readonly isSendHidden = computed(() => {
    return this.order()?.order?.method === ORDER_METHOD_VALUE.CODEOffice;
  });

  sendRollback = effect(() => {
    if (this.#store.sendCommentError()) {
      untracked(() => {
        const lastComment = this.comments()[this.comments().length - 1];
        this.comment.setValue(lastComment.message);
        this.#store.update({
          orderRes: {
            ...this.order(),
            comments: this.comments().slice(0, -1),
          },
        });
      });
    }
  });

  scrollBottomEffect = effect(() => {
    if (this.order()) {
      asyncScheduler.schedule(
        () => this.bottom().nativeElement.scrollIntoView(),
        10,
      );
    }
  });

  form = this.#fb.group({
    comment: '',
  });

  get comment() {
    return this.form.get('comment');
  }

  get commentEmpty() {
    return !this.comment.getRawValue().trim();
  }

  get sendDisabled() {
    return this.commentEmpty || this.loading() || !this.order();
  }

  get shimmerArray(): Array<number> {
    const count = 10;

    return Array.from({ length: count });
  }

  ngOnDestroy() {
    this.#store.resetRequestStatus('sendComment');
  }

  send() {
    if (this.sendDisabled) return;
    const now = new Date().toJSON();
    const newComment = {
      message: this.comment.getRawValue() as string,
      createdAt: now,
      userId: 'me',
      id: now,
    };

    this.comment.setValue('');
    this.#store.sendComment(newComment);
  }
}
